import { Outlet } from "react-router-dom";

export default function Activities() {
  return <Outlet />;
}
